<template>
    <div style="height: 100vh">
        <Navbar v-if="$route.meta.navbar"/>
        <!-- <Breadcrumb v-if="$route.meta.navbar" /> -->
        <div class="container-fluid">

            <h3>
                Support Issues Planner
                <span class="float-end">            
                    <button class="btn btn-primary" @click.prevent="newissue">
                        <fa-icon
                            name="plus"                        
                        />
                        Add new
                    </button>
                </span>
                <span class="float-end me-2 ">            
                    <button class="btn btn-secondary" @click.prevent="showlist">
                        <fa-icon
                            name="list"                        
                        />
                        List view
                    </button>
                </span>
                <span class="float-end me-2">
                    <div class="input-group input-group-sm my-0">
                        <input
                            class="form-control"
                            v-model="search"
                            placeholder="Search..."
                            type="text"
                            @input="data_search"
                            autocomplete="off"
                        />
                        <button
                            class="btn btn-outline-secondary"
                            type="button"
                            @click="search = '';issues_get(['reported','inprogress','fixed','approved', 'waiting'])"
                        >
                            X
                        </button>
                    </div>
                </span>

                <span class="float-end me-4">
                    <select
                        class="form-select form-select-sm"
                        v-model="user_id"
                        @change="issues_get(['reported','inprogress','fixed','approved', 'waiting'])"           
                    >
                        <option v-for="user in users" :key="user.value" :value="user.value">
                            {{ user.text }}
                        </option>
                    </select>  
                </span>
                <span class="float-end me-4">
                    <select
                        class="form-select form-select-sm"
                        v-model="priority_id"
                        @change="issues_get(['reported','inprogress','fixed','approved', 'waiting'])"           
                    >
                        <option v-for="priority in priorities" :key="priority.value" :value="priority.value">
                            {{ priority.text }}
                        </option>
                    </select>  
                </span>
            </h3>
            <div v-if="loading" class="row flex-row flex-sm-nowrap py-3 ms-3">
                <div class="spinner-border spinner-border-lg text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>&nbsp;&nbsp;Loading...
            </div>
            <div v-if="!loading" class="row flex-row flex-sm-nowrap py-1">
                <!-- Reported -->
                <div class="col-sm-6 col-md-3 col-xl-3">
                    <div class="card bg-light">
                        <div class="card-body">
                            <h6 class="card-title text-truncate py-2">Reported</h6>
                            <div class="items">
                            <div v-bind:key="issue.id" v-for="issue in issues_reported">
                                <div class="card draggable shadow-sm" :id="issue.id" draggable="true" @dragstart="drag($event)">
                                <div class="card-body p-2">
                                    <div class="card-title" style="cursor: default">
                                        <span class="float-end">
                                            <span :style="{ color: issue.issue_priority=='High'?'red':issue.issue_priority=='Normal'?'#ffc107':issue.issue_priority=='Low'?'green':'blue' }">
                                                ●
                                            </span>
                                        </span>
                                        <a @click.prevent.stop="openissue(issue.id)" class="font-small font-weight-light">{{ issue.id }} {{ issue.issue_heading }}</a>
                                    </div>
                                    <p>
                                        <span class="small">Assigned to: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.issue_assigned_to }}</a></span><br>    
                                        <span class="small">Consultant: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.consultant_id }}</a></span><br>    
                                        <span class="small">Reported: </span><span class="small font-weight-bold">{{ issue.issue_reported_date }}</span><br>
                                        <span class="small">Estimate(hrs): </span><span class="small font-weight-bold">{{ issue.estimate_hours }}</span>
                                    </p>
                                </div>
                                </div>
                                <div class="dropzone rounded" :id="'D'+issue.id+':reported'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                            </div>
                            <div v-if="issues_reported.length==0">
                                <div class="card draggable shadow-sm" :id="10000001" draggable="true" @dragstart="drag($event)">
                                <div class="dropzone rounded" :id="'D0:reported'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- In progress -->
                <div class="col-sm-6 col-md-3 col-xl-3">
                    <div class="card bg-default">
                        <div class="card-body">
                            <h6 class="card-title text-truncate py-2">In progress</h6>
                            <div class="items">
                            <div v-bind:key="issue.id" v-for="issue in issues_inprogress">
                                <div class="card draggable shadow-sm" :id="issue.id" draggable="true" @dragstart="drag($event)">
                                <div class="card-body p-2">
                                    <div class="card-title" style="cursor: default">
                                        <span class="float-end">
                                            <span :style="{ color: issue.issue_priority=='High'?'red':issue.issue_priority=='Normal'?'#ffc107':issue.issue_priority=='Low'?'green':'blue' }">
                                                ●
                                            </span>
                                        </span>
                                        <a @click.prevent.stop="openissue(issue.id)" class="font-small font-weight-light">{{ issue.id }} {{ issue.issue_heading }}</a>
                                    </div>
                                    <p>
                                        <span class="small">Assigned to: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.issue_assigned_to }}</a></span><br>    
                                        <span class="small">Consultant: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.consultant_id }}</a></span><br>    
                                        <span class="small">Reported: </span><span class="small font-weight-bold">{{ issue.issue_reported_date }}</span><br>
                                        <span class="small">Estimate(hrs): </span><span class="small font-weight-bold">{{ issue.estimate_hours }}</span>
                                    </p>
                                </div>
                                </div>
                                <div class="dropzone rounded" :id="'D'+issue.id+':inprogress'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                            </div>
                            <div v-if="issues_inprogress.length==0">
                                <div class="card draggable shadow-sm" :id="10000002" draggable="true" @dragstart="drag($event)">
                                <div class="dropzone rounded" :id="'D0:inprogress'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="card bg-danger mt-2">
                        <div class="card-body">
                            <h6 class="card-title text-truncate py-2 text-white">Waiting</h6>
                            <div class="items">
                            <div v-bind:key="issue.id" v-for="issue in issues_waiting">
                                <div class="card draggable shadow-sm" :id="issue.id" draggable="true" @dragstart="drag($event)">
                                <div class="card-body p-2">
                                    <div class="card-title" style="cursor: default">
                                        <a @click.prevent.stop="openissue(issue.id)" class="font-small font-weight-light">{{ issue.id }} {{ issue.issue_heading }}</a>
                                    </div>
                                    <p>
                                        <span class="small">Assigned to: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.issue_assigned_to }}</a></span><br>    
                                        <span class="small">Consultant: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.consultant_id }}</a></span><br>    
                                        <span class="small">Reported: </span><span class="small font-weight-bold">{{ issue.issue_reported_date }}</span><br>
                                        <span class="small">Estimate(hrs): </span><span class="small font-weight-bold">{{ issue.estimate_hours }}</span>
                                        <span class="small">Time spent(hrs): </span><span class="small font-weight-bold">{{ issue.actual_hours }}</span>
                                    </p>
                                </div>
                                </div>
                                <div class="dropzone rounded" :id="'D'+issue.id+':waiting'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                            </div>
                            <div v-if="issues_waiting.length==0">
                                <div class="card draggable shadow-sm" :id="10000004" draggable="true" @dragstart="drag($event)">
                                <div class="dropzone rounded" :id="'D0:waiting'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Fixed -->
                <div class="col-sm-6 col-md-3 col-xl-3">
                    <div class="card bg-warning">
                        <div class="card-body">
                            <h6 class="card-title text-truncate py-2">Fixed</h6>
                            <div class="items">
                            <div v-bind:key="issue.id" v-for="issue in issues_fixed">
                                <div class="card draggable shadow-sm" :id="issue.id" draggable="true" @dragstart="drag($event)">
                                <div class="card-body p-2">
                                    <div class="card-title" style="cursor: default">
                                        <span class="float-end">
                                            <span :style="{ color: issue.issue_priority=='High'?'red':issue.issue_priority=='Normal'?'#ffc107':issue.issue_priority=='Low'?'green':'blue' }">
                                                ●
                                            </span>
                                        </span>
                                        <a @click.prevent.stop="openissue(issue.id)" class="font-small font-weight-light">{{ issue.id }} {{ issue.issue_heading }}</a>
                                    </div>
                                    <p>
                                        <span class="small">Assigned to: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.issue_assigned_to }}</a></span><br>    
                                        <span class="small">Consultant: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.consultant_id }}</a></span><br>    
                                        <span class="small">Reported: </span><span class="small font-weight-bold">{{ issue.issue_reported_date }}</span><br>
                                        <span class="small">Time spent(hrs): </span><span class="small font-weight-bold">{{ issue.actual_hours }}</span>
                                    </p>
                                </div>
                                </div>
                                <div class="dropzone rounded" :id="'D'+issue.id+':fixed'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                            </div>
                            <div v-if="issues_fixed.length==0">
                                <div class="card draggable shadow-sm" :id="10000003" draggable="true" @dragstart="drag($event)">
                                <div class="dropzone rounded" :id="'D0:fixed'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Approved -->
                <div class="col-sm-6 col-md-3 col-xl-3">
                    <div class="card bg-success">
                        <div class="card-body">
                            <h6 class="card-title text-truncate py-2 text-white">Approved</h6>
                            <div class="items">
                            <div v-bind:key="issue.id" v-for="issue in issues_approved">
                                <div class="card draggable shadow-sm" :id="issue.id" draggable="true" @dragstart="drag($event)">
                                <div class="card-body p-2">
                                    <div class="card-title" style="cursor: default">
                                        <a @click.prevent.stop="openissue(issue.id)" class="font-small font-weight-light">{{ issue.id }} {{ issue.issue_heading }}</a>
                                    </div>
                                    <p>
                                        <span class="small">Assigned to: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.issue_assigned_to }}</a></span><br>    
                                        <span class="small">Consultant: <a :href="'mailto: '+issue.issue_assigned_to">{{ issue.consultant_id }}</a></span><br>    
                                        <span class="small">Reported: </span><span class="small font-weight-bold">{{ issue.issue_reported_date }}</span><br>
                                        <span class="small">Time spent(hrs): </span><span class="small font-weight-bold">{{ issue.actual_hours }}</span>
                                    </p>
                                </div>
                                </div>
                                <div class="dropzone rounded" :id="'D'+issue.id+':approved'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                            </div>
                            <div v-if="issues_approved.length==0">
                                <div class="card draggable shadow-sm" :id="10000004" draggable="true" @dragstart="drag($event)">
                                <div class="dropzone rounded" :id="'D0:approved'" @drop="drop($event)" @dragover="allowDrop($event)" @dragleave="clearDrop($event)"> &nbsp; </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>                   
            </div>
            
            <!-- Edit Modal -->
            <div v-if="editmode" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title">{{currentissue==-1?'Add':'Edit'}} Support Issue {{ currentissue==-1?'':currentissue }}</h3>
                            <button type="button" class="btn-close" @click="closeissue" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <Maintenance tablename="g_supportissues" :standalone="currentissue" />
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="closeissue">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Delete Confirmation Modal -->
            <div v-if="deleteshow" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Delete issue?</h5>
                            <button type="button" class="btn-close" @click="canceldeleteissue" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            Do you really want to delete this issue?
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger w-100" @click="deleteissue">Yes, delete</button>
                            <button type="button" class="btn btn-secondary w-100 mt-2" @click="canceldeleteissue">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import Maintenance from './Maintenance';
import Navbar from './Navbar.vue'
// import Breadcrumb from './Breadcrumb.vue'
// helpers
function hasClass(target, className) {
    return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
}

function addClass(ele,cls) {
  if (!hasClass(ele,cls)) ele.className += " "+cls;
}

function removeClass(ele,cls) {
  if (hasClass(ele,cls)) {
    var reg = new RegExp('(\\s|^)'+cls+'(\\s|$)');
    ele.className=ele.className.replace(reg,' ');
  }
}

export default {
  name: 'Planner',
  components: {
    Maintenance,
    Navbar,
    // Breadcrumb,
  },
  mounted() {
      this.users_get();
      this.priorities_get();
      this.issues_get(['reported','inprogress','fixed','approved', 'waiting']);
  },
  data: function() {
      return {
          user_id: '',
          users: [],
          priority_id: '',
          priorities: [],
          search: '',
          currentissue: 0,
          editmode: false,
          deleteissueid: 0,
          deleteshow: false,
          allissues: [],
          issues_reported: [],
          issues_inprogress: [],
          issues_fixed: [],
          issues_approved: [],
          issues_waiting: [],
          issues_closed: [],
          searchcalc: false,
          loading: true,
      }
  },
  methods: {
    showlist() {
        this.$router.push('/supportissues');
    },
    data_search: _.debounce(function() {
        this.searchcalc = true
        setTimeout(function() {
            this.issues_get(['reported','inprogress','fixed','approved', 'waiting']);
            this.searchcalc = false;
        }.bind(this),500)
    },300),
    users_get() {
        let users = [];
        users.push({ value: '', text: 'All users' })
        this.$store.dispatch('records_readlist', { table_name: 'i_user', filter: { i_group: { operator: '=', value: 2 }}, orderby: 'i_name', order: 'ASC' })
        .then((res) => {
            res.data.result.map((r) => {
                if (r.email != '' && r.i_name != '') {
                    users.push({
                        value: r.email,
                        text: r.i_name,
                    });
                }
            });
            this.users = users;
            this.user_id = '';
        })
    },
    priorities_get() {
        let priorities = [];
        priorities.push({ value: '', text: 'All priorities' })
        this.$store.dispatch('records_readlist', { table_name: 'g_supportpriorities' })
        .then((res) => {
            res.data.result.map((r) => {
                priorities.push({
                    value: r.priority_name,
                    text: r.priority_name+' priority',
                });
            });
            this.priorities = priorities;
            this.priority_id = '';
        })
    },
    deleteissue() {
      this.$store.dispatch('record_delete', {
        table_name: 'g_supportissues',
        id: this.deleteissueid,
      })
      .then(() => {            
        this.deleteshow = false;
        this.deleteissueid = 0;
        this.issues_get(['reported','inprogress','fixed','approved', 'waiting']);
      });  
    },
    confirmdeleteissue(deleteissueid) {
        this.deleteissue = deleteissueid;
        this.deleteshow = true;
    },
    canceldeleteissue() {
        this.deleteshow = false;
        this.deleteissueid = 0;
    },
    newissue() {
        this.currentissue = -1;
        this.editmode = true;
    },
    closeissue() {
        this.issues_get(['reported','inprogress','fixed','approved', 'waiting']);
        this.editmode = false;
    },
    openissue(issueId) {
        this.currentissue = issueId;
        this.editmode = true;
    },
    drag(event) {
        event.dataTransfer.setData("text/plain", event.target.id);
    },
    allowDrop (ev) {
        ev.preventDefault();
        if (hasClass(ev.target,"dropzone")) {
            addClass(ev.target,"droppable");
        }
    },
    drop(event) {
        event.preventDefault();
        const issueId = event.dataTransfer.getData("text/plain");
        const statusName = event.target.id.substring(event.target.id.indexOf(':')+1);
        // let oldStatusId = -1; // find in array - use to only update the changed lanes?
        let newStatusId = 0;
        switch (statusName) {
            case "reported": { newStatusId = 1; break; }
            case "inprogress": { newStatusId = 2; break; }
            case "fixed": { newStatusId = 3; break; }
            case "approved": { newStatusId = 4; break; }
            case "waiting": { newStatusId = 5; break; }
        }
        const record = {
            issue_status: newStatusId,
        };
        const parms = { table_name: 'g_supportissues', id: issueId, record: record };
        this.$store.dispatch("record_put", parms)
        .then(() => {
            this.issues_get(['reported','inprogress','fixed','approved', 'waiting']);
        });
    },
    clearDrop (ev) {
        removeClass(ev.target,"droppable");
    },
    issues_get(refresh) {
        this.loading = true;
        if (refresh.indexOf('reported')>-1) { this.issues_reported = []; }
        if (refresh.indexOf('inprogress')>-1) { this.issues_inprogress = []; }
        if (refresh.indexOf('fixed')>-1) { this.issues_fixed = []; }
        if (refresh.indexOf('approved')>-1) { this.issues_approved = []; }
        if (refresh.indexOf('waiting')>-1) { this.issues_waitingd = []; }
        let filter = {};
        let filtersep = 'AND';
        if (this.user_id != 0) {
            filter['issue_assigned_to'] = {
                operator: '=',
                value: this.user_id,
            }
            filtersep = 'AND';
        }
        if (this.priority_id != '') {
            filter['issue_priority'] = {
                operator: '=',
                value: this.priority_id,
            }
            filtersep = 'AND';
        }
        if (this.search != "") {
            filter = {};
            filter['issue_assigned_to'] = {
                operator: 'LIKE',
                value: '*'+this.search+'*',
            }
            filter['issue_heading'] = {
                operator: 'LIKE',
                value: '*'+this.search+'*',
            }
            filter['issue_description'] = {
                operator: 'LIKE',
                value: '*'+this.search+'*',
            }
            filter['consultant_id'] = {
                operator: 'LIKE',
                value: '*'+this.search+'*',
            }
            this.filter = filter;
            filtersep = 'OR';
            this.priority_id = '';
            this.user_id = '';
        }
        this.$store.dispatch("records_readlist", { table_name: 'g_supportissues', filter: filter, filtersep: filtersep, orderby: 'g_supportissues.issue_priority DESC, g_supportissues.issue_reported_date', order: 'ASC' })
        .then((resp) => {
            this.allissues = resp.data.result;
            if (refresh.indexOf('reported')>-1) { 
                this.issues_reported = resp.data.result.filter( (r) => {
                    this.loading = false;
                    return r.issue_state == "Open" && r.issue_status == "Reported";
                });
            }
            if (refresh.indexOf('inprogress')>-1) {
                this.issues_inprogress = resp.data.result.filter( (r) => {
                    this.loading = false;
                    return r.issue_state == "Open" && r.issue_status == "In progress";
                });
            }
            if (refresh.indexOf('fixed')>-1) {
                this.issues_fixed = resp.data.result.filter( (r) => {
                    this.loading = false;
                    return r.issue_state == "Open" && r.issue_status == "Fixed";
                });
            }
            if (refresh.indexOf('approved')>-1) {
                this.loading = false;
                this.issues_approved = resp.data.result.filter( (r) => {
                    return r.issue_state == "Open" && r.issue_status == "Approved";
                });
            }
            if (refresh.indexOf('waiting')>-1) {
                this.loading = false;
                this.issues_waiting = resp.data.result.filter( (r) => {
                    return r.issue_state == "Open" && r.issue_status == "Waiting";
                });
            }
            this.issues_closed = resp.data.result.filter( (r) => {
                this.loading = false;
                return r.issue_state == "Closed";
            });
            this.loading = false;
        });
    },
  }
}
</script>
<style>
.card.draggable {
    margin-bottom: 1rem;
    cursor: grab;
}

.droppable {
    background-color: var(--bs-success);
    min-height: 80px;
    margin-bottom: 1rem;
}
</style>
